export default __webpack_public_path__ + "static/media/okta.1bb6ad0c.PNG";